var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCourseBookWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "white",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.6667 1.66668C6.6667 0.746257 5.92044 0 5.00001 0C4.07959 0 3.33333 0.746257 3.33333 1.66668C3.33333 2.58711 4.07959 3.33336 5.00001 3.33336C5.92044 3.33336 6.6667 2.58711 6.6667 1.66668ZM0 4.00745V8.11332C0 8.48916 0.251669 8.81833 0.614172 8.9175L4.58337 10V4.16662L1.05251 3.2037C0.522505 3.05911 0 3.45828 0 4.00745ZM5.41667 4.16662L8.94753 3.2037C9.47754 3.05911 10 3.45828 10 4.00745V8.11332C10 8.48916 9.74837 8.81874 9.38587 8.9175L5.41667 10V4.16662Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseBookWhite);
export default __webpack_public_path__ + "static/media/course-book-white.da00c4f4956febd12c4206c595af146f.svg";
export { ForwardRef as ReactComponent };